<template>
<!-- h3是h3 li是1.2rem -->
  <div class="onlycard">
    <div class="row">
      <div class="ulcard">
        <h4>{{ newcard.who }}</h4>
        <!-- <a href @click.prevent="sd">Object</a> -->

        <ul>
          <li v-for="(item, index) in newcard.things" :key="index">{{ item }}</li>
        </ul>

        <!-- <div class="button">
          <Button :msg="newcard.button"
          :btncolor="btncolor"
          @clickbutton="changeUrl"></Button> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// import Button from '@/components/only_button.vue';

export default {
  props: {
    card: {
      type: Object,
      default: () => ({
        who: 'who',
        things: ['First', 'Second', 'Third'],
        button: 'button',
        buttonUrl: 'buttonUrl',
      }),
    },
  },
  data() {
    return {
      newcard: this.card,
      btncolor: ['quatercard_one', 'hover-btn'],
    };
  },
  components: {
    // Button,
  },
  methods: {
    sd() {
      console.log(this.newcard);
    },
    changeUrl() {
      const vm = this;
      const card = vm.newcard;
      const Url = card.buttonUrl;
      console.log(`點擊按鈕後會跳轉至[服務模式${Url}]`);
      this.$router.push(`${Url}`);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.onlycard {
  .row {
    height: 100%;
    .ulcard {
      background-color: #fff;
      margin: 2px;
      padding: 20px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      h3 {
        margin-bottom: 30px;
      }
      ul {
        height: 100%;
        margin-bottom: 0;
        padding: 0;
        list-style-position: inside;
        li {
          font-size: 1.2rem;
          color: #49535d;
          margin-bottom: 20px;
        }
      }
      .button {
        align-self: flex-end;
      }
    }
  }
}
</style>
